import { CheckCircle, Clock, ShieldCheck, AlertTriangle } from 'lucide-react';

/**
 * Get display information for a certificate status
 * @param {string} status - The certificate status
 * @param {boolean} isExpired - Whether the certificate is expired
 * @returns {Object} Status information including label, color, and icon
 */
export const getStatusInfo = (status, isExpired) => {
  if (isExpired) {
    return {
      label: 'Expired',
      color: 'bg-red-100 text-red-800 hover:bg-red-100',
      icon: AlertTriangle
    };
  }

  switch (status) {
    case 'Pending Signature':
      return {
        label: 'Pending Signature',
        color: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
        icon: Clock
      };
    case 'Complete Signatures':
      return {
        label: 'Valid',
        color: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
        icon: ShieldCheck
      };
    case 'Released':
      return {
        label: 'Active',
        color: 'bg-green-100 text-green-800 hover:bg-green-100',
        icon: CheckCircle
      };
    case 'Renewed':
      return {
        label: 'Renewed',
        color: 'bg-purple-100 text-purple-800 hover:bg-purple-100',
        icon: CheckCircle
      };
    default:
      return {
        label: status || 'Unknown',
        color: 'bg-gray-100 text-gray-800 hover:bg-gray-100',
        icon: ShieldCheck
      };
  }
};